module.exports = __webpack_public_path__ + "img/2.4d2831b4.jpeg";